import get from 'lodash/get'

export default (otherField) => function (value, parentVm) {
  let compareTo = ''
  if (typeof otherField === 'string') {
    compareTo = (typeof parentVm[otherField] !== 'undefined' ? parentVm[otherField] : get(this, otherField))
  } else {
    compareTo = otherField
  }

  if (value === null || value === undefined || value === '') {
    return true
  }

  if (compareTo === null || compareTo === undefined || compareTo === '') {
    return true
  }

  return value >= compareTo
}



// WEBPACK FOOTER //
// ./src/validators/greaterOrEqualTo.js